// Shared dose dropdown options used by both pregnancy and preconception
// assessment forms. Kept identical across arms; if they ever need to
// diverge, split here rather than copying the arrays back into the forms.

// Active observation. Hidden from the "previous dose" picker, which only
// appears once on_treatment is ticked — a patient already on levothyroxine
// cannot have had no treatment. It stays available in the recommendation
// pickers, where proposing discontinuation is a legitimate clinical call.
export const NO_TREATMENT_DOSE = "0 mcg - No treatment (Active observation)";

// "7 x (200+125)" (325 mcg/day) was removed 2026-07-19: it exceeds the
// algorithm's 300 mcg/day safety cap (backend config tops out at
// "7 x (200+100)"), so it could never concord. No collected record used it.
export const stableDoses = [
  NO_TREATMENT_DOSE,
  "7 x 25", "7 x 50", "7 x 62", "7 x 75", "7 x 88", "7 x 100", "7 x 112",
  "7 x 125", "7 x 137", "7 x 150", "7 x 175", "7 x 200",
  "7 x (200+25)", "7 x (200+50)", "7 x (200+62)", "7 x (200+75)",
  "7 x (200+88)", "7 x (200+100)",
];

export const combinationDoses = [
  "5 x 25", "6 x 25", "6 x 25 + 1 x 50", "5 x 25 + 2 x 50", "4 x 25 + 3 x 50", "5 x 50",
  "4 x 50 + 3 x 25", "5 x 50 + 2 x 25", "6 x 50 + 1 x 25", "6 x 50 + 1 x 62", "6 x 62",
  "5 x 50 + 2 x 62", "4 x 50 + 3 x 62", "4 x 62 + 3 x 50", "5 x 62 + 2 x 50", "6 x 62 + 1 x 50",
  "6 x 62 + 1 x 75", "6 x 75", "5 x 62 + 2 x 75", "4 x 62 + 3 x 75", "4 x 75 + 3 x 62",
  "5 x 75 + 2 x 62", "6 x 75 + 1 x 62",
  "6 x 50 + 1 x 75", "5 x 50 + 2 x 75", "4 x 50 + 3 x 75", "3 x 50 + 4 x 75", "2 x 50 + 5 x 75", "1 x 50 + 6 x 75",
  "6 x 75 + 1 x 88", "5 x 75 + 2 x 88", "4 x 75 + 3 x 88",
  "4 x 88 + 3 x 75", "5 x 88 + 2 x 75", "6 x 100", "6 x 88 + 1 x 75", "6 x 88 + 1 x 100",
  "5 x 88 + 2 x 100", "4 x 88 + 3 x 100", "4 x 100 + 3 x 88", "6 x 112", "5 x 100 + 2 x 88",
  "6 x 100 + 1 x 88",
  "6 x 75 + 1 x 100", "5 x 75 + 2 x 100", "4 x 75 + 3 x 100", "3 x 75 + 4 x 100", "2 x 75 + 5 x 100", "1 x 75 + 6 x 100",
  "6 x 100 + 1 x 112", "5 x 100 + 2 x 112", "4 x 100 + 3 x 112",
  "4 x 112 + 3 x 100", "6 x 125", "5 x 112 + 2 x 100", "6 x 112 + 1 x 100",
  "6 x 112 + 1 x 125", "5 x 112 + 2 x 125", "4 x 112 + 3 x 125", "4 x 125 + 3 x 112",
  "5 x 125 + 2 x 112", "6 x 125 + 1 x 112",
  "6 x 100 + 1 x 125", "5 x 100 + 2 x 125", "4 x 100 + 3 x 125", "3 x 100 + 4 x 125", "2 x 100 + 5 x 125", "1 x 100 + 6 x 125",
  "6 x 125 + 1 x 137", "5 x 125 + 2 x 137",
  "4 x 125 + 3 x 137", "4 x 137 + 3 x 125", "5 x 137 + 2 x 125", "6 x 137 + 1 x 125",
  "6 x 137 + 1 x 150", "5 x 137 + 2 x 150", "4 x 137 + 3 x 150", "4 x 150 + 3 x 137",
  "5 x 150 + 2 x 137", "6 x 150 + 1 x 137",
  "6 x 125 + 1 x 150", "5 x 125 + 2 x 150", "4 x 125 + 3 x 150", "3 x 125 + 4 x 150", "2 x 125 + 5 x 150", "1 x 125 + 6 x 150",
  "6 x 150 + 1 x 175", "5 x 150 + 2 x 175",
  "4 x 150 + 3 x 175", "4 x 175 + 3 x 150", "5 x 175 + 2 x 150", "6 x 175 + 1 x 150",
  "6 x 175 + 1 x 200", "5 x 175 + 2 x 200", "4 x 175 + 3 x 200", "4 x 200 + 3 x 175",
  "5 x 200 + 2 x 175", "6 x 200 + 1 x 175", "5 x 200 + 2 x (200+25)",
  "4 x (200+25) + 3 x 200", "4 x 200 + 3 x (200+50)", "4 x (200+50) + 3 x 200",
  "5 x (200+50) + 2 x 200", "6 x (200+50) + 1 x 200",
];
